export default __webpack_public_path__ + "static/media/016-hydrant.b9f2fc27.png";